function initSoveranest(root = document) {
  root.querySelectorAll('[data-sv-product]').forEach(product => {
    if (product.dataset.initialized) return;
    product.dataset.initialized = 'true';
    const select = product.querySelector('[data-sv-variant]');
    const swatches = product.querySelector('[data-sv-swatches]');
    const price = product.querySelector('[data-sv-price]');
    const add = product.querySelector('[data-sv-add]');
    const update = (changeUrl = false) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const shade = option.dataset.shade;
      product.querySelector('[data-sv-shade-name]').textContent = option.textContent.trim();
      product.querySelectorAll('[data-sv-group]').forEach(group => { group.hidden = group.dataset.svGroup !== shade; });
      product.querySelectorAll('[data-sv-shade]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.svShade === shade)));
      const cents = Number(option.dataset.price);
      price.hidden = cents <= 0;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:window.Shopify?.currency?.active || 'EUR'}).format(cents / 100);
      add.disabled = cents <= 0 || option.dataset.available !== 'true';
      add.textContent = cents <= 0 ? add.dataset.soonLabel : option.dataset.available === 'true' ? add.dataset.addLabel : add.dataset.soldLabel;
      if (changeUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        url.searchParams.set('sv_shade', shade);
        history.replaceState({}, '', url);
      }
    };
    swatches.hidden = false;
    select.classList.add('sv-sr-only');
    product.querySelectorAll('[data-sv-shade]').forEach(button => button.addEventListener('click', () => {
      const option = Array.from(select.options).find(o => o.dataset.shade === button.dataset.svShade);
      if (option) { select.value = option.value; update(true); }
    }));
    select.addEventListener('change', () => update(true));
    const desired = new URL(location.href).searchParams.get('sv_shade');
    const requested = Array.from(select.options).find(o => o.dataset.shade === desired);
    if (requested) select.value = requested.value;
    update();
    product.querySelectorAll('[data-sv-thumbnail]').forEach(button => button.addEventListener('click', () => {
      const group = button.closest('[data-sv-group]');
      const image = group.querySelector('.sv-main-photo img');
      image.src = button.dataset.svThumbnail;
      image.removeAttribute('srcset');
      image.alt = button.getAttribute('aria-label');
      group.querySelector('[data-sv-photo-number]').textContent = `0${button.dataset.svIndex} / 05`;
      group.querySelectorAll('[data-sv-thumbnail]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    product.querySelectorAll('[data-sv-quantity]').forEach(button => button.addEventListener('click', () => {
      const quantity = product.querySelector('input[name="quantity"]');
      quantity.value = Math.max(1, Math.min(99, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.svQuantity)));
    }));
  });
}
document.addEventListener('DOMContentLoaded', () => initSoveranest());
document.addEventListener('shopify:section:load', event => initSoveranest(event.target));
